<script>
// This component we can import and use anywhere to have that chat button and display
// conversation on click getStream is integrated with it so no need for props or anything
import ChatList from '@components/chat/chat-list.vue';

import { homeMethods, homeComputed } from '@state/helpers';

export default {
  components: { ChatList },
  props: {},
  data() {
    return {};
  },
  computed: {
    ...homeComputed,
  },
  mounted() {},
  methods: {
    ...homeMethods,
  },
};
</script>

<template>
  <div class="chat-btn-wrapper">
    <div class="chat-button">
      <!-- ChatList have all the getStream sdk work, close is for if we
      click anywhere but the chat list then it'll close it -->
      <ChatList v-if="viewChatList" @close="setViewChatList(!viewChatList)" />

      <!-- Render different buttons wether if chatList open or closed -->
      <BaseButton v-if="!viewChatList" class="button btn-primary large" @click="setViewChatList(!viewChatList)">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="none" d="M0 0h24v24H0z"/><path d="M6.455 19L2 22.5V4a1 1 0 011-1h18a1 1 0 011 1v14a1 1 0 01-1 1H6.455zm-.692-2H20V5H4v13.385L5.763 17zM11 10h2v2h-2v-2zm-4 0h2v2H7v-2zm8 0h2v2h-2v-2z"/></svg>
      </BaseButton>
      <BaseButton v-if="viewChatList" class="button btn-primary large" @click="setViewChatList(!viewChatList)">
        <BaseIcon class="icon-arrow" name="times" />
      </BaseButton>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.chat-btn-wrapper {
  bottom: 5%;
  position: fixed;
  right: calc(5vw - 3rem);
  z-index: 100;

  .chat-button {
    height: 6rem;
    position: relative;
    width: 6rem;

    .messages-container {
      bottom: 80%;
      position: absolute;
      right: 20%;
    }

    .btn-primary {
      align-items: center;
      border-radius: 50%;
      display: flex;
      height: 100%;
      justify-content: center;
      padding: unset;
      padding: 13px;
      position: absolute;
      width: 100%;
      z-index: 5;
      svg {
        height: 100%;
        width: 100%;

        path:last-child {
          fill: white;
        }
      }
    }
  }
}
</style>
